import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { setMiddle, setOpenGameOverModal, setSomethingHappend, removeFromHand } from '../store/gameSlice';
import { setGameData } from '../store/gameSummarySlice';
import { setSessionData } from '../store/gameSessionSlice';
import axios from '../services/api-axios';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { applyThrowEffect } from './gameEffects';
import { DealHandDto, GameMessage, GameOverResponse, ThrowCardResponse } from './types/GameMessage';

// Define types for payload (this will help with TypeScript)
interface PrivateMessagePayload {
  body: string;
}

const useGameMessageHandler = () => {
  const dispatch = useAppDispatch();
  const myUsername = useAppSelector((state) => state.onlineUsers.username);

  // This handler is handed to STOMP once, when the game topic is subscribed, and
  // that happens before Header has fetched /api/user/info. Closing over the value
  // would pin it to the empty string for the life of the subscription, so every
  // "was this me?" check silently fails. A ref keeps the callback reading the
  // current value.
  const myUsernameRef = useRef(myUsername);
  useEffect(() => {
    myUsernameRef.current = myUsername;
  }, [myUsername]);

  const onGameMessageReceived = async (payload: PrivateMessagePayload) => {
    const jsonResponse = JSON.parse(payload.body); // Parse the payload once
    console.log('%cWsContainer::onGameMessageReceived:::::::::::::::::::::::::' + payload.body,  'background-color: #ff6347; color: white; padding: 5px; font-size: 16px; border-radius: 3px;');

    // Destructure commonly used properties for easier access
    // const { nextPlayer, thrownByPlayer, status, playerEffect, roundState, cardDto, gameId, firstPlayer, players } = jsonResponse;
    const msg:GameMessage<any> = jsonResponse as GameMessage<any>;

    var gameMessage;
    if (msg.type == "DEAL_HAND"){ gameMessage = msg as GameMessage<DealHandDto>; handleDealHand(gameMessage.payload)}
    if (msg.type == "THROW_CARD_RESPONSE"){gameMessage = msg as GameMessage<ThrowCardResponse>; handleThrowCard(gameMessage.payload)}
    if (msg.type == "GAME_OVER_RESPONSE"){gameMessage = msg as GameMessage<GameOverResponse>; handleGameOver(gameMessage.payload)}
    console.log("GAME MESSAGE::::" + JSON.stringify(msg), 'background-color: #ff6347; color: white; padding: 5px; font-size: 16px; border-radius: 3px;')
    
  };
  
  const handleThrowCard = async (message: ThrowCardResponse) => {
    if (message.autoThrown && message.thrownByPlayer === myUsernameRef.current) {
      toast("⏱️ Time's up — a card was thrown for you", { position: "top-center", autoClose: 3000 });
      // A card you play yourself is dropped from the hand by the click handler.
      // The timer plays this one server-side, so nothing has removed it here and
      // it would otherwise stay on screen as a card you no longer hold.
      dispatch(removeFromHand({ rank: message.cardDto.rank, suit: message.cardDto.suit }));
    }
    await applyThrowEffect(dispatch, message);
  }
  const handleDealHand = (message: DealHandDto) => {
    switch(message.status){
      case 'MIDDLE':
        const middle = message.cards.map((card:any) => {
          card.rotate = Math.floor(Math.random() * 71) - 35; // Assign random rotation
          return card;
        });
        dispatch(setMiddle({ middle }));
        console.log("Setting middle");
        break;
      // DEAL IS SENT TO PRIVATE MESSAGE
      // case 'DEAL': 
        // break;
    }
  }
  const handleGameOver = async (message: GameOverResponse) => {
        dispatch(setSomethingHappend({ message: "KRAJ" }));
        await new Promise(resolve => setTimeout(resolve, 1000));
        dispatch(setSomethingHappend({ message: null }));
        dispatch(setOpenGameOverModal({ value: true }));
        dispatch(setSessionData({
          sessionActive: message.sessionActive,
          sessionId: message.sessionId,
          sessionTarget: message.sessionTarget,
          team1SessionScore: message.team1SessionScore,
          team2SessionScore: message.team2SessionScore,
          sessionOver: message.sessionOver,
          sessionWinner: message.sessionWinner
        }));
        // Fetch game summary after game over
        try {
          const res = await axios.get(`/rest/game/${message.gameId}/`);
          console.log(res);
          dispatch(setGameData({ gameData: res.data }));
        } catch (error) {
          console.error(error);
        }

  }

  return onGameMessageReceived;
};
export default useGameMessageHandler;
